export enum RouteName {
  list = 'fraud-providers-list',
  create = 'fraud-providers-create',
  edit = 'fraud-providers-edit',
  details = 'fraud-providers-details',
}
